import { t } from 'ember-intl';
import { PhFilePdf } from 'ember-phosphor-icons';
import type { TOC } from '@ember/component/template-only';
import type TasAssetModel from 'tio-data/models/tas-asset';

interface DiscardedListSignature {
  Args: {
    /** Soft-removed assets within the current step. Empty array → render nothing. */
    assets: TasAssetModel[];
  };
  Element: HTMLDivElement;
}

/**
 * "Discarded:" tray below the document rows. Persists discarded files for the
 * remainder of the wizard session so the employee has an audit trail of what
 * they tried to upload (Figma frames B5–B9).
 *
 * Renders nothing when `assets` is empty so it stays out of the way until the
 * employee actually discards something.
 */
const DiscardedList: TOC<DiscardedListSignature> = <template>
  {{#if @assets.length}}
    <div
      class="flex flex-wrap items-center gap-2 rounded bg-tio-gray-50 px-3 py-2 text-xs"
      data-test-discarded-list
      ...attributes
    >
      <span class="font-semibold text-tio-gray-600">
        {{t "tas.attachments.discarded"}}
      </span>
      {{#each @assets as |asset|}}
        <span
          class="inline-flex items-center gap-1.5 rounded border tio-border-default tio-bg-surface px-2 py-1 text-tio-gray-600 line-through"
          title={{asset.filename}}
        >
          <PhFilePdf @size="12" class="shrink-0" />
          <span class="truncate max-w-[14rem]">{{asset.filename}}</span>
        </span>
      {{/each}}
    </div>
  {{/if}}
</template>;

export default DiscardedList;
